<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import type { PersonMonsterType } from '@/types/monster'
import { socketEmitAsync } from '@/utils/web-socket'
import { QuestionFilled } from '@element-plus/icons-vue'

const userStore = useUserStore()

const emits = defineEmits(['start'])
defineProps<{ fightCount: number }>()

async function handleStart() {
  if (userStore.consumables.secretCaveFight <= 0) return ElMessage.warning('挑战券不足，请前往活动页面获取')
  await socketEmitAsync<PersonMonsterType>({ type: 'startSecretCaveFight' })
  emits('start')
}
</script>

<template>
  <div class="border-wrap eternal-tower">
    <h4 class="special">
      秘藏洞窟
      <div class="help-info" style="margin-left: 5px">
        <el-popover placement="top" width="100%" trigger="click">
          <template #reference>
            <el-icon size="20"><QuestionFilled /></el-icon>
          </template>
          <div class="affix">
            <h4>秘藏洞窟说明</h4>
            <p>1. 秘藏洞窟为活动副本，持有<span class="info">挑战券</span>时通过可获得装备及活动积分奖励。</p>
            <p>2. 挑战失败时<span class="grow">不会消耗</span><span class="info">挑战券</span></p>
            <p>2. 活动积分可在庆典页面兑换珍贵道具。</p>
            <p>3. 奖励规则：</p>
            <p style="text-indent: 2em">a. 未进阶：</p>
            <p style="text-indent: 4em">i: 3<span class="legend">传说</span>装备</p>
            <p style="text-indent: 4em">ii: 随机奖励：强化保护券、升星石、远古石、高级祈福券、潜能石</p>
            <p style="text-indent: 2em">b. 已进阶：</p>
            <p style="text-indent: 4em">i: 2<span class="darkGold">暗金</span>装备</p>
            <p style="text-indent: 4em">ii: 随机奖励：精造石、高级祈福券、圣物藏宝图、刻印券、潜能石</p>
            <p style="text-indent: 2em">c. 80<span class="info">活动积分</span></p>
          </div>
        </el-popover>
      </div>
    </h4>
    <p>持有挑战券：{{ userStore.consumables.secretCaveFight }}</p>
    <p>已挑战次数：{{ fightCount }}</p>
    <div style="margin: 10px 0">
      <el-button type="success" plain @click="handleStart"> 进入 </el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.eternal-tower {
  flex-flow: column;
}
</style>
